import { render } from "./PlanPurchaseIndex.vue?vue&type=template&id=6a1cb5d0&scoped=true"
import script from "./PlanPurchaseIndex.vue?vue&type=script&lang=js"
export * from "./PlanPurchaseIndex.vue?vue&type=script&lang=js"

import "./PlanPurchaseIndex.vue?vue&type=style&index=0&id=6a1cb5d0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1cb5d0"]])

export default __exports__